import { get } from 'cookies-js';

export default function getCsrfToken() {
    return get('_99csrf');
}



// WEBPACK FOOTER //
// ./~/@99designs/ddo/lib/getCsrfToken.js